import React from 'react';
import PageLayout from '../../components/PageLayout';
import PageHero from '../../components/PageHero';

const BREADCRUMBS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services/ifys-services' },
  { label: 'Disability Services' },
];

const DisabilityServicesPage = () => {
  return (
    <PageLayout activeLink="services">
      <PageHero
        title="Disability Services"
        backgroundImage="/images/service-headers/disabilityservices.jpg"
        breadcrumbs={BREADCRUMBS}
        variant="split"
      />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-6">
          Disability Services
        </h2>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Supports By Design */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 sm:p-10 flex flex-col transition-shadow duration-300 hover:shadow-lg">
            <h3 className="text-2xl font-bold text-ifys-blue mb-4">Supports By Design</h3>
            <div className="space-y-4 text-gray-700 text-base leading-relaxed flex-1">
              <p>
                At Supports by Design we believe disability services should be tailored to meet each
                individual&rsquo;s goals and assist them to develop their skills and independence. Since
                2001, Supports by Design has been supporting people of all ages and needs, with high
                quality services in their home or the community.
              </p>
              <p>
                Our person centred, outcome focused services, are provided by staff with extensive
                experience in supporting high and complex needs. We match our staff to your needs,
                based on qualifications, location and interests.
              </p>
            </div>
            <a
              href="https://supportsbydesign.com.au"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-ifys-blue font-semibold hover:underline"
            >
              Visit supportsbydesign.com.au
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
            </a>
          </div>

          {/* No Limits */}
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 sm:p-10 flex flex-col transition-shadow duration-300 hover:shadow-lg">
            <h3 className="text-2xl font-bold text-ifys-blue mb-4">No Limits</h3>
            <div className="space-y-4 text-gray-700 text-base leading-relaxed flex-1">
              <p>
                Our Support Coordination team will help you implement your NDIA plan. With a combined
                180 years of experience in the disability sector, our team has the NDIA experience and
                the sector knowledge needed to find you the right services and to organise these
                services to ensure the best use of your plan.
              </p>
              <p>
                We can provide Support Coordination and Specialist Support Coordination.
              </p>
            </div>
            <a
              href="https://www.nolimits.org.au"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-ifys-blue font-semibold hover:underline"
            >
              Visit nolimits.org.au
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
            </a>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default DisabilityServicesPage;
